module.exports = __webpack_public_path__ + "82318cce69d3655d9978f154e9a315e7.svg";